import { Component, input } from '@angular/core';

@Component({
  selector: 'avs-no-data-placeholder',
  standalone: true,
  templateUrl: './no-data-placeholder.component.html',
})
export class NoDataPlaceholderComponent {
  resultContent = input(false);
  noDataText = input('No Data');
  hasBigPadding = input(false);
}
